import { makeStyles } from "tss-react/mui";

const useRowSettingsStyles = makeStyles()((theme) => ({
  iconButton: {
    border: `1px solid ${theme.palette.strokes.defaultGrey}`,
    backgroundColor: theme.palette.surface.light,
    borderRadius: "0 4px 4px 0",
  },
}));

export default useRowSettingsStyles;
